export const controls = [

    "theme",
    "download",
    "play",
    "page",
    "close",
    "autofit",
    "zoom-in",
    "zoom-out",
    "prev",
    "next",
    "fullscreen"
];

export const controls_default = {

    "page": 1,
    "close": 1,
    "autofit": 1,
    "zoom-in": 1,
    "zoom-out": 1,
    "prev": 1,
    "next": 1,
    "fullscreen": 1
};

/**
 * @enum {number}
 */

export const keycodes = {

    BACKSPACE: 8,
    ESCAPE: 27,
    SPACEBAR: 32,
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    NUMBLOCK_PLUS : 107,
    PLUS: 187,
    DOWN: 40,
    NUMBLOCK_MINUS: 109,
    MINUS: 189
};
